import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentUserId } from 'store/storeValtio';
import Spinner from '../spinner/Spinner';
import { lookupMed } from 'helpers/medicationHelpers';

export default function SupplementSearch({med, updateLabelId}) {
  const currentUserId = getCurrentUserId();
  const navigate = useNavigate();

  console.log('SupplementSearch', med.name, med.brand);

  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(true);
  const [supList, setSupList] = useState([]);
  const nameRef = useRef(med.name);
  const brandRef = useRef(med.brand);

  useEffect(() => {
    console.log('SupplementSearch UE');
    // let i = document.getElementById( 'med_name' );
    // i.value = med.name;
    // i = document.getElementById( 'med_brand' );
    // i.value = med.brand;

    async function getSupplements(name, brand) {
        console.log('getSupps UE', name, brand);

        try{
            let url = `https://api.itookitwhen.com/Supplement/${name}/${brand}`;
            url = url.replace(" ", "%20");
            console.log('search', url);
            const response = await fetch(url);
            const result = await response.json();
            console.log('supList UE', supList);
            setSupList(result);
            setSearching(false);
        }catch(error) {
            return [];
        }
      }
    
    console.log(nameRef.current, brandRef.current);
    getSupplements(nameRef.current, brandRef.current);
    setLoading(false);
  },[]);

  if (loading) return(<Spinner />);

  async function getSupplements(name, brand) {
    console.log('getSupps', name, brand);
    let result = [];
    try{
        if (!brand) brand = '*';
        if (!name) name = '*';
        const url = `https://api.itookitwhen.com/Supplement/${name}/${brand}`;
        console.log('getSupps', url);
        const response = await fetch(url);
        result = await response.json();
    }catch(error) {
        console.log('getSupplements error', error);
    }
    return result;
  }

async function search() {
    const name = nameRef.current.value;
    const brand = brandRef.current.value;
    setSearching(true);
    console.log('search', name, brand);
    const sl = await getSupplements(name, brand);
    console.log('supList', sl)
    setSupList(sl);
    setSearching(false);
  }

  async function selectSupp(s) {
    console.log('selectSupp', s);
    const lid = s.labelId;
    updateLabelId(lid);
    console.log('label', lid);
  }

  function nameChange(e) {
    console.log('nameChange', e.target.value);
    const txt = e.target.value;
    const tu = txt.toUpperCase();
    nameRef.current.value = tu;
  }

  function brandChange(e) {
    console.log('brandChange', e.target.value);
    const txt = e.target.value;
    const tu = txt.toUpperCase();
    brandRef.current.value = tu;
  }

  function manualEntry() {

  }

  console.log('SL', supList);
  if (!supList) return (<Spinner/>);
  // see supps.css for styling
  return (
    <div>
        <div className='medBody'>
            <div className='medName'>
                <input 
                    ref={nameRef} 
                    defaultValue={med.name}
                    onChange={(e)=>nameChange(e)} 
                    className='medInput' 
                    id='med_name' 
                    name='med_name' 
                    type='text' 
                    autoComplete='off' 
                    required /> 
            </div>
            <div className='medName'>
                <input 
                    ref={brandRef} 
                    defaultValue={med.brand}
                    onChange={(e)=>brandChange(e)} 
                    className='medInput' 
                    id='med_brand' 
                    name='med_brand' 
                    type='text' 
                    autoComplete='off' 
                    required /> 
            </div>
            <div className='medName flex flex-row justify-around'>
                <button 
                    className='rawBtn bg-blue-300 border-2 border-blue-900 px-4 py-2'
                    onClick={()=>search()}>
                    Update Search
                </button>
                <button 
                    className='rawBtn bg-blue-300 border-2 border-blue-900 px-4 py-2'
                    onClick={()=>manualEntry()}>
                    Manual Entry
                </button>
            </div>
            <div className='lcard'>
                <div className='flex flex-col w-full justify-center items-center'>
                    {/* <div key={ix} className='mcard border-2 border-gray-200 mt-2 mb-1'>
                        <div className='mcard-header flex justify-between' onClick={()=>selectSupp(s)}> */}
                    <table id='supps' className='w-10/12 mt-4 text-base small:text-lg font-semibold'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Brand</th>
                                <th>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                        {!searching && supList.map((s,ix) => {
                        //const li = bn.name === medsCreateState.brand ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
                            return (
                                <tr key={ix} onClick={()=>selectSupp(s)}>
                                    <td>{s.name}</td>
                                    <td>{s.brand}</td>
                                    <td>{s.quantity}</td>
                                </tr>
                            )
                        })}
                        {searching && 
                            <tr>
                                <td colSpan='3'>Searching...</td>
                            </tr>
                        }
                        {!searching && supList.length === 0 && 
                            <tr>
                                <td colSpan='3'>No Data Found</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
        )
}